import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      className="relative w-10 h-10 rounded-full bg-white border border-zen-border hover:bg-zen-subtle/20 flex items-center justify-center transition-colors"
      title={dark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      aria-label={dark ? "Passa al tema chiaro" : "Passa al tema scuro"}
    >
      {dark
        ? <Sun size={17} strokeWidth={1.6} className="text-zen-primary"/>
        : <Moon size={17} strokeWidth={1.6} className="text-zen-ink"/>}
    </button>
  );
}
